import React, { useEffect, useRef } from "react"
import cn from "classnames"
import { ErrorIcon } from "./Field"
import styles from "../../styles/scss/components/form/formSystem.module.scss"

// Result of a submit: the request failed, or (for forms that stay on the
// page) it succeeded. Takes focus when it appears so the outcome is announced
// and visible even when the submit button is far down the page.
export const SUBMIT_ERROR =
    "Sorry, something went wrong and your form was not sent. Please try again in a few minutes."

// focusOnShow={false} is for static demos (the style guide), where taking
// focus on mount would scroll the page to the message
const FormStatus = ({ status, children, focusOnShow = true }) => {
    const ref = useRef(null)
    useEffect(() => {
        if (focusOnShow && status && ref.current) ref.current.focus()
    }, [status, focusOnShow])

    if (!status) return null
    const isError = status === "error"
    return (
        <div
            ref={ref}
            tabIndex={-1}
            role={isError ? "alert" : "status"}
            className={cn(styles.status, { [styles.statusSuccess]: !isError })}
        >
            {isError && <ErrorIcon />}
            <span>{children || (isError ? SUBMIT_ERROR : "Thank you. Your form was sent.")}</span>
        </div>
    )
}

export default FormStatus
